const WFHpStatusObj = {
  onReview: "審核中",
  reject: "退回",
  agree: '通過',
  revoke:'抽回',
}

export default WFHpStatusObj